var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "wrapper" },
    [
      _c("c-textarea", {
        attrs: {
          label: "Комментарий",
          clearable: true,
          placeholder: "Желаемый график работы, опыт работы и т.д.",
          "required-mark": _vm.field.required,
          "max-length": _vm.maxLength,
          invalid: !!_vm.error,
          error: _vm.error,
        },
        model: {
          value: _vm.localValue,
          callback: function ($$v) {
            _vm.localValue = $$v
          },
          expression: "localValue",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }